import React, { useEffect, useMemo, useState } from 'react';

/**
 * Obrazek, który znika, gdy pliku nie ma — zamiast pokazywać ikonę zepsutego
 * zdjęcia. Katalog grafik aut uzupełnia się stopniowo, więc brak pliku jest
 * stanem normalnym, nie błędem.
 *
 * `src` przyjmuje też TABLICĘ ścieżek — próbuje po kolei i pokazuje pierwszą,
 * która się wczyta. Tak działa spadek ze zdjęcia wersji na zdjęcie modelu
 * (patrz utils/logoAuta.js).
 */
const ObrazekAuta = ({ src, alt, className }) => {
  const zrodla = useMemo(() => (Array.isArray(src) ? src.filter(Boolean) : [src].filter(Boolean)), [src]);
  const [i, setI] = useState(0);

  // Nowe auto = próbujemy od najbardziej szczegółowej ścieżki.
  useEffect(() => { setI(0); }, [zrodla.join('|')]); // eslint-disable-line react-hooks/exhaustive-deps

  if (i >= zrodla.length) return null;
  return (
    <img
      key={zrodla[i]}
      src={zrodla[i]}
      alt={alt || ''}
      className={className}
      loading="lazy"
      onError={() => setI((n) => n + 1)}
    />
  );
};

export default ObrazekAuta;
